export const GET_DEED_REPORT = "get_deed_report";
export const RE_SEND_DEED = "re_send_deed"